// Copyright © 2019 Mapotempo

window.Paloma.start();
